module.exports = __webpack_public_path__ + "static/media/bg-image-44.74649b79.jpg";